module.exports = __webpack_public_path__ + "static/media/208-Arzt_ID_25.a300c7ad.mp3";